import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'

import styles from './HotelStatusCheckResultDialog.module.scss'

const HotelStatusCheckResultDialog = ({
  isCompleted,
  pendingSteps,
  statusName,
  onClose
}) => (
  <ConfirmationDialog
    title="Hotel status check"
    positiveMessage="Close"
    onConfirm={onClose}
    onClose={onClose}
    onPressEnter={onClose}
    maxWidth={520}
  >
    {isCompleted ? (
      <p className={styles.summary}>
        All mandatory steps are complete. Hotel status is now <b>{statusName}</b>.
      </p>
    ) : (
      <>
        <p className={styles.summary}>
          Hotel status stays <b>{statusName}</b>. These mandatory steps are still pending:
        </p>
        <ul className={styles.pendingList}>
          {pendingSteps.map(({ title, value }) => (
            <li key={title} className={styles.pendingItem}>
              <span className={styles.pendingTitle}>{title}</span>
              <span className={styles.pendingValue}>{value}</span>
            </li>
          ))}
        </ul>
      </>
    )}
    <p className={styles.footnote}>
      Hotel status is also checked automatically every hour.
    </p>
  </ConfirmationDialog>
)

export default HotelStatusCheckResultDialog
